'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _logJs = require('./log.js');

var _logJs2 = _interopRequireDefault(_logJs);

/**
 * Object containing the default behaviors for available handler methods.
 *
 * @private
 * @type {Object}
 */
var defaultBehaviors = {
  get: function get(obj, key) {
    return obj[key];
  },
  set: function set(obj, key, value) {
    obj[key] = value;
    return true;
  }
};

/**
 * Expose private objects publicly using a Proxy to log deprecation warnings.
 *
 * Browsers that do not support Proxy objects will simply return the `target`
 * object, so it can be directly exposed.
 *
 * @param {Object} target The target object.
 * @param {Object} messages Messages to display from a Proxy. Only operations
 *                          with an associated message will be proxied.
 * @param {String} [messages.get]
 * @param {String} [messages.set]
 * @return {Object} A Proxy if supported or the `target` argument.
 */

exports['default'] = function (target) {
  var messages = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  if (typeof Proxy === 'function') {
    var _ret = (function () {
      var handler = {};

      // Build a handler object based on those keys that have both messages
      // and default behaviors.
      Object.keys(messages).forEach(function (key) {
        if (defaultBehaviors.hasOwnProperty(key)) {
          handler[key] = function () {
            _logJs2['default'].warn(messages[key]);
            return defaultBehaviors[key].apply(this, arguments);
          };
        }
      });

      return {
        v: new Proxy(target, handler)
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  }
  return target;
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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